<div class="togglegroup" id="tab-one-c" *ngIf="!showDetailLicense && !gettingDetailsByLicense">

  <swiper *ngIf=" !gettingLicenses" class="license-swiper" [slidesPerView]="1" [spaceBetween]="50"
    [pagination]="{ clickable: true }" [controller]="{ control: controlledSwiper }">
    (swiper)="setControlledSwiper($event)"
    (slideChange)="onSlideChange()">

    <ng-template swiperSlide *ngFor="let license of completeLicenseData;index as i;" class="license-card-container">
      <app-license-card *ngIf="!gettingLicenses" [licensesData]="license" [licenseIndex]="i" [zonesRows]="zonesRows"
        [usingAspect]="'DASHBOARD'" [licensesLength]="completeLicenseData.length" [userData]="personData">
      </app-license-card>
      <div class="innermenu">
        <ul>
          <li *ngIf="license.sanction?.sanctionType !== 'SUSPENSION'">
            <a class="modal__trigger global-hand" data-modal="modal01" (click)="openModal(license.id)">
              Suspender licencia
            </a>
          </li>
          <li *ngIf="license.sanction?.sanctionType === 'SUSPENSION'">
            <a class="modal__trigger global-hand" data-modal="modal01" (click)="onReactivate(license.id)">
              Reactivar licencia
            </a>
          </li>
          <li>
            <a class="global-hand" (click)="showDetailDelete(license.id)">
              {{shouldShowModify ? 'Modificar Licencia' : 'Eliminar Licencia'}}
            </a>
          </li>
        </ul>
      </div>
    </ng-template>
  </swiper>


  <div class="license-card-container" *ngFor="let item of completeLicenseData; index as i;">
    <div class="innermenu" [ngClass]="{' u-bt u-bt--grey u-pt30 u-mt50': i > 0}">
      <ul>
        <li *ngIf="buttonShow[i] === 'SUSPEND'">
          <a class="modal__trigger global-hand underline" (click)=" openModal(item.id)">
            Suspender licencia
          </a>
        </li>
        <li *ngIf="buttonShow[i] === 'REACTIVATE'">
          <a class="modal__trigger global-hand underline" (click)=" onReactivate(item.id)">
            Reactivar licencia
          </a>
        </li>
        <li>
          <a class="toggle global-hand underline" (click)="  showDetailDelete(item.id)">
            {{shouldShowModify ? 'Modificar Licencia' : 'Eliminar Licencia'}}
          </a>
        </li>
      </ul>
    </div>

    <app-license-card [licensesData]="item" [licenseIndex]="i" [zonesRows]="zonesRows"
      [licensesLength]="completeLicenseData.length" [userData]="personData"></app-license-card>

  </div>

  <div *ngIf="completeLicenseData.length === 0">No tiene licencias vigentes</div>

  <app-suspension-modal *ngIf="shouldShowModal" [visible]="shouldShowModal" [licenseId]="idLicense" [userId]="userId"
    (handleClose)="closeModal()" [licenseSelected]="licenseSelected" [personData]="personData"></app-suspension-modal>
</div>
<div class="loader-licenses" *ngIf="gettingDetailsByLicense" style="margin-top: 20px !important; position: absolute;">
  <app-loader></app-loader>
</div>

<app-search-driver-licenses-delete-equipment
*ngIf="!shouldShowModify && showDetailLicense && this.selectedLicenseIndex >= 0"
[showDetailLicense]="showDetailLicense"
[detailLicense]="detailLicenseByIdLicense"
[licenseSelectedId]="idLicense"
(handleBack)="onBack()"
(refreshLicenseCards)="refreshLicenseCards.emit()"
[personData]="personData"
></app-search-driver-licenses-delete-equipment>


<app-modify-equipment
*ngIf="shouldShowModify && showDetailLicense && this.selectedLicenseIndex >= 0"
[showDetailLicense]="showDetailLicense"
[detailLicense]="detailLicenseByIdLicense"
[completeLicenseData]="this.completeLicenseData[this.selectedLicenseIndex]"
[licenseSelectedId]="idLicense"
(handleBack)="onBack()"
(refreshLicenseCards)="refreshLicenseCards.emit()"
[personData]="personData"
></app-modify-equipment>
